// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Banner-Banner-module__Banner";
var _2 = "webpack-components-core-Banner-Banner-module__default";
var _3 = "webpack-components-core-Banner-Banner-module__brand";
var _4 = "webpack-components-core-Banner-Banner-module__brand-strong";
var _5 = "webpack-components-core-Banner-Banner-module__danger";
var _6 = "webpack-components-core-Banner-Banner-module__info";
var _7 = "webpack-components-core-Banner-Banner-module__lg";
var _8 = "webpack-components-core-Banner-Banner-module__md";
var _9 = "webpack-components-core-Banner-Banner-module__medium";
var _a = "webpack-components-core-Banner-Banner-module__neutral";
var _b = "webpack-components-core-Banner-Banner-module__primary";
var _c = "webpack-components-core-Banner-Banner-module__sm";
var _d = "webpack-components-core-Banner-Banner-module__strong";
var _e = "webpack-components-core-Banner-Banner-module__success";
var _f = "webpack-components-core-Banner-Banner-module__text";
var _10 = "webpack-components-core-Banner-Banner-module__warning";
var _11 = "webpack-components-core-Banner-Banner-module__weak";
var _12 = "webpack-components-core-Banner-Banner-module__xl";
var _13 = "webpack-components-core-Banner-Banner-module__xs";
var _14 = "webpack-components-core-Banner-Banner-module__xxl";
export { _1 as "Banner", _2 as "_default", _3 as "brand", _4 as "brand-strong", _5 as "danger", _6 as "info", _7 as "lg", _8 as "md", _9 as "medium", _a as "neutral", _b as "primary", _c as "sm", _d as "strong", _e as "success", _f as "text", _10 as "warning", _11 as "weak", _12 as "xl", _13 as "xs", _14 as "xxl" }
